/**
 * A map that handles chart object id and temp id mappings when duplicating charts
 */
class IdAndTempIdMap {
	constructor() {
		// Holds new realid/tempid mapped to an old real id
		this.oldIdsToNewIds = {}
		// Holds new realid/tempid mapped to an old temp id
		this.oldTempIdsToNewIds = {}
	}

	/**
	 * Add a new mapping of old ids to new ids. Note that both the id and tempId
	 * do not need to be provided.
	 */
	addIds({ oldId, oldTempId }, { id, tempId }) {
		if (oldId) {
			// We need to store both ids so that we can find new temp ids with
			// old real ids
			this.oldIdsToNewIds[oldId] = { id, tempId }
		}
		if (oldTempId) {
			this.oldTempIdsToNewIds[oldTempId] = { id, tempId }
		}
	}

	/**
	 * Retrieve new ids given a pair of old ids. An object is always returned,
	 * but it is possible that both ids in the object are null. Note that both
	 * the id and tempId do not need to be provided.
	 */
	getNewIds({ id, tempId }) {
		let ids = { id: null, tempId: null }
		if (id && this.oldIdsToNewIds[id]) {
			ids = this.oldIdsToNewIds[id]
		}

		if (!ids.id && !ids.tempId && tempId && this.oldTempIdsToNewIds[tempId]) {
			ids = this.oldTempIdsToNewIds[tempId]
		}

		return ids
	}
}

export default IdAndTempIdMap
IdAndTempIdMap.__filename__ = 'charts/id-tempid-map.js'
